module.exports = "/_next/static/images/16b253aafe991e84b4bc6c84451b578a-doc.svg";